import {Link} from "react-router";

import {shortDateTime} from "@/lib/format.tsx";
import {ServiceUsage} from "@/lib/types/checks.ts";
import {DateFormatName, TimeFormatName} from "@/lib/types/common.ts";

interface InstantCheckoutRequestSuccessProps {
  serviceUsage: ServiceUsage;
  timeFormat: TimeFormatName;
  dateFormat: DateFormatName;
  timezone: string;
}

export const InstantCheckoutRequestSuccess = ({
  serviceUsage,
  timeFormat,
  dateFormat,
  timezone,
}: InstantCheckoutRequestSuccessProps) => {
  const requestSent = shortDateTime(serviceUsage.request_sent_on, dateFormat, timeFormat, timezone);
  return (
    <small>
      <p>
        You have reached the maximum number of <strong>{serviceUsage.limit_name}</strong> Checks available in your
        account.
      </p>
      <p>
        A purchase request <strong>was sent</strong> to the owner of this account on {requestSent}. Once it is paid, the
        requested Checks will be added to the account.
      </p>
      <p>
        If you have any questions don’t hesitate to <Link to="/contact">contact us</Link>.
      </p>
    </small>
  );
};
